import { Drawer as DrawerPrimitive } from 'vaul';

export { DrawerPrimitive };
